import { render, staticRenderFns } from "./StockView.vue?vue&type=template&id=1f76d14e&scoped=true"
import script from "./StockView.vue?vue&type=script&lang=js"
export * from "./StockView.vue?vue&type=script&lang=js"
import style0 from "./StockView.vue?vue&type=style&index=0&id=1f76d14e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f76d14e",
  null
  
)

export default component.exports